import { EnumMultiSelectFieldV2Props } from "./EnumMultiSelectFieldV2";
import {
  Option,
  EnumMultiSelectFieldValue,
  EnumMultiSelectFieldSingleValue,
  EnumMultiSelectFieldV2Value,
} from "../../types/fieldTypes";
import React, { useEffect } from "react";
import { MultiSelectComponent } from "@syncfusion/ej2-react-dropdowns";

export const useEnumMultiSelectFieldV2 = (
  props: EnumMultiSelectFieldV2Props
) => {
  const multiSelectRef = React.useRef<MultiSelectComponent | null>(null);
  const [localValue, setLocalValue] = React.useState<EnumMultiSelectFieldValue>(
    props.value || []
  );

  const localOptionValues: Option<EnumMultiSelectFieldSingleValue>[] = [
    ...(props.optionValues || []),
  ];

  const setNoRecordsTemplate = () => {
    if (!!multiSelectRef.current && !!props.noRecordsTemplate) {
      multiSelectRef.current.noRecordsTemplate = props.noRecordsTemplate(
        multiSelectRef.current
      ) as any;
    }
  };

  const sanitizeValue = (values?: EnumMultiSelectFieldV2Value) => {
    return values?.filter((value) => value != null || value !== undefined);
  };

  const getOptions = (values?: EnumMultiSelectFieldV2Value) => {
    return values?.map((value) =>
      props.optionValues.find((ov) => ov.value === value)
    );
  };

  const handleValueChange = (newValue: EnumMultiSelectFieldValue) => {
    if (multiSelectRef.current && newValue !== undefined) {
      /**
       * Setting local value to detect change faster than rerendering,
       * allowing the UI to adjust styles like require as it occurs.
       */
      const sanitizedValue = sanitizeValue(newValue) || [];
      setLocalValue(sanitizedValue);
      multiSelectRef.current.value = sanitizedValue as
        | number[]
        | string[]
        | boolean[];
    }
  };

  useEffect(() => {
    if (props.value) {
      handleValueChange(props.value);
    }
  }, [props.value]);

  return {
    localValue,
    setLocalValue,
    localOptionValues,
    getOptions,
    setNoRecordsTemplate,
    multiSelectRef,
    sanitizeValue,
    handleValueChange,
  };
};
